import { ApprovalRequestActionType } from '../types/enums/ApprovalRequestActionType.enum';

export const getResourceReviewAlertSeverity = (actionTypeId: number): 'info' | 'error' | 'success' => {
  switch (actionTypeId) {
    case ApprovalRequestActionType.CREATE:
      return 'success';
    case ApprovalRequestActionType.UPDATE:
      return 'info';
    case ApprovalRequestActionType.DELETE:
      return 'error';
    default:
      return 'info';
  }
};
